import { VariableSummary } from '@mtna/variable-service-core-ts';

export class RdsDataDictionaryToggleEvent {
  constructor(public selected: boolean, public variable: VariableSummary) {}
}
